import { render, staticRenderFns } from "./ShipmentProfileRateList.vue?vue&type=template&id=b25aee74&"
import script from "./ShipmentProfileRateList.vue?vue&type=script&lang=js&"
export * from "./ShipmentProfileRateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports